import React, {useState} from 'react';
import {Button, Modal, Spinner} from "react-bootstrap";
import {Partner} from "../models";
import { PartnersService } from '../Partners.service';

interface DeletePartnerConfirmModalProps {
    partner: Partner;
    handleSubmitClose: () => void;
    handleRejectClose: () => void;
}

export function DeletePartnerConfirmModal(props: DeletePartnerConfirmModalProps) {
    const [saving, setSaving]: [boolean, any] = useState(false);
    const [savingError, setSavingError]: [boolean, any] = useState(false);

    const confirmSubmit = async () => {
        setSaving(true);
        setSavingError(false);

        try {
            await PartnersService.deletePartner(props.partner.id)
            setTimeout(() => {
                setSaving(false);
                props.handleSubmitClose();
            }, 100);
        } catch(e){
            console.error('Saving failed', e);
            setSaving(false);
            setSavingError(true);
        }
    };

    const rejectSubmit = () => {
        props.handleRejectClose();
    };

    return (
        <>
            <Modal
                show={true}
                centered
            >
                <Modal.Header>
                    <Modal.Title>
                        Partneri kustutamine
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    Kas oled kindel, et soovid partnerit kustutada?
                </Modal.Body>
                <Modal.Footer className="d-flex flex-row align-items-end justify-content-around flex-wrap mb-1">
                    <Button variant="info"
                            onClick={() => rejectSubmit()}
                            type="button"
                            className={"d-flex align-items-center"}>
                        <span className='px-2'>Loobu</span>
                    </Button>
                    <Button variant="danger"
                            onClick={confirmSubmit}
                            type="button"
                            className="d-flex align-items-center">
                        {
                            !saving &&
                            <span className='px-2'>Kustuta</span>
                        }
                        {
                            saving &&
                            <>
                                <span className='px-2'>Kustutamine…</span>
                                <Spinner size={"sm"} animation={"border"}/>
                            </>
                        }
                    </Button>
                </Modal.Footer>
                {
                    !saving && savingError &&
                    <span className="d-flex justify-content-end text-danger px-2 pb-2">
                        Viga salvestamisel, proovi mõne hetke pärast uuesti.
                    </span>
                }
            </Modal>
        </>
    );
}
